import { leadQueryKeys } from "@gymflow/api";
import { LeadSourceDTO } from "@gymflow/types";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import useGymflowModels from "../../../../../store";
import { FormSelectInput, FormSelectInputProps } from "../FormSelectInput";

type FormSelectLeadStatusProps<T> = Omit<
  FormSelectInputProps<T, LeadSourceDTO>,
  "dataFetchingQuery"
>;

export const FormSelectLeadStatus = <T,>(
  props: FormSelectLeadStatusProps<T>,
) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  return (
    <FormSelectInput
      placeholder={t("forms.leadStatus.label")}
      label={t("forms.leadStatus.label")}
      {...props}
      dataFetchingQuery={(search) =>
        infiniteQueryOptions({
          queryKey: leadQueryKeys.leadStatus({ search }),
          queryFn: async () => (await api.leadApi.findStatus()).data,
          select: (data) => {
            return {
              pageParams: data.pageParams,
              pages: data.pages.map((page) =>
                page
                  .map((status) => ({
                    id: status.id,
                    label: status.name,
                    value: status,
                  }))
                  .filter(
                    (status) =>
                      !search ||
                      status.label.toLowerCase().includes(search.toLowerCase()),
                  ),
              ),
            };
          },
          getNextPageParam: () => undefined,
          initialPageParam: undefined,
        })
      }
      isSearchable
    />
  );
};
